import { useEffect, useState } from "react";
import { useSession } from "../../context/session-context";
import DashboardWrapper from "../dashboard-wrapper/DashboardWrapper";
import { Loader } from "@bms-ai/bms-ai-ui-lib/components";

const LandingPage = () => {
  const { getPlatformToken } = useSession();
  const [isTokenReady, setIsTokenReady] = useState(false);

  useEffect(() => {
    const initializeToken = async () => {
      try {
        // await getToken();
        // await getModuleToken();
        await getPlatformToken();
        setIsTokenReady(true);
      } catch (error) {
        // Handle token initialization error gracefully
        console.error('Failed to initialize platform token:', error);
        // Keep loader visible on error
      }
    };

    initializeToken();
  }, []);

  if (!isTokenReady) {
    return <Loader />;
  }
  return <DashboardWrapper />;
};

export default LandingPage;
